// import React from "react";
// import { NavLink } from "react-router-dom";
// import { useParams, useNavigate } from "react-router-dom";
// import { useEffect, useState } from "react";
// import Sidebar from "../components/Sidebar";
// import { useJwt } from "react-jwt";
// import {
//     EditNotificationAPI,
//     getByIdNotification,
//     GetProductStatus,
//     api_url,
// } from "../apiconfig/authService";
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import dayjs from 'dayjs';

// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
// function Editnotification(props) {
//     const navigate = useNavigate();
//     const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
//     if (isExpired) navigate("/");

//     const setMediaTableViewMessage = props.setMessage;

//     const [mediaData, setMediaData] = useState({});
//     const [editedMediaData, setEditedMediaData] = useState({});
//     const [value, setValue] = React.useState(dayjs());
//     const [message, setMessage] = useState("");
//     const [isMessageRed, setIsMessageRed] = useState(false);
//     const { id } = useParams();
//     const [newImage, setNewImage] = useState(null);
//     const [statusData, setStatusData] = useState([]);
//     const imageInputRef = React.createRef();

//     console.log(mediaData);
//     console.log("id>>>>>>>>>>", id)
//     useEffect(() => {
//         (async () => {
//             try {
//                 const response = await getByIdNotification(
//                     id,
//                     localStorage.getItem("accessToken")
//                 );
//                 console.log("response.data.response??", response.data.response)
//                 setMediaData(response.data.response);
//                 setEditedMediaData(response.data.response);
//             } catch (error) {
//                 console.log(error);
//             }
//         })();
//     }, []);

//     useEffect(() => {
//         (async () => {
//             try {
//                 const statusResponse = await GetProductStatus(
//                     localStorage.getItem("accessToken")
//                 );
//                 setStatusData(statusResponse.data);
//             } catch (error) {
//                 console.log(error);
//             }
//         })();
//     }, []);

//     const handleTitleChange = (e) => {
//         const temp = { ...editedMediaData };
//         temp.title = e.target.value;
//         setEditedMediaData(temp);
//     };

//     const handleStatusChange = (e) => {
//         const temp = { ...editedMediaData };
//         temp.statusid = e.target.value;
//         setEditedMediaData(temp);
//     };

//     const validateInput = () => {
//         if (editedMediaData.name === "") throw new Error("Name is required.");
//     };

//     console.log(editedMediaData);

//     const handleSubmitClick = async (e) => {
//         e.preventDefault();

//         try {
//             // validateInput();
//         } catch (error) {
//             setIsMessageRed(true);
//             setMessage(error.message);
//             window.scrollTo(0, 0);
//             return;
//         }

//         let response;
//         const data = {
//             "id": id,
//             "title": editedMediaData.title,
//             "shortdescription": editedMediaData.shortdescription,
//             "selecteddate": editedMediaData.selecteddate
//         }

//         try {
//             response = await EditNotificationAPI(
//                 data,
//                 localStorage.getItem("accessToken")
//             );
//             if (response.status === 200) {
//                 setMediaTableViewMessage(response.data.message);
//                 navigate("/notification");
//             }
//         } catch (err) {
//             if (err.response && err.response.data && err.response.data.error) {
//                 setIsMessageRed(true);
//                 setMessage(err.response.data.error);
//                 window.scrollTo(0, 0);
//             } else {
//                 setIsMessageRed(true);
//                 setMessage("An error occurred. Please try again later.");
//                 window.scrollTo(0, 0);
//             }
//             console.log(err);
//         }
//     };
//     const handleChange = (newValue) => {
//         const now = dayjs();
//         if (newValue && newValue.isBefore(now)) {
//             // Ignore or optionally correct to now
//             setValue(now);
//         } else {
//             setValue(newValue);
//         }
//     };
//     return (
//         <div className="dashboard-content">
//             <Sidebar />
//             {/* <div className="mobileOption d-flex align-items-center justify-content-between">
//           <div  className="buyMore">
//             <img className="img-fluid" src={logoImg} alt=""/>
//           </div>
//           <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
//         </div> */}
//             <div className="body-cart tab-content dasContent p-4 bg-white rounded">
//                 <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
//                     <h1 className="heading h4 mb-0 fw-bold">Edit Media</h1>
//                     <div className="d-inline-flex gap-2">
//                         <NavLink to="/media" className="btn btn-primary">
//                             View All
//                         </NavLink>
//                     </div>
//                 </div>

//                 {message && (
//                     <div
//                         style={{ color: isMessageRed ? "red" : "black" }}
//                         className="alert alert-primary"
//                         role="alert"
//                     >
//                         {message}
//                     </div>
//                 )}

//                 <div
//                     role="tabpanel"
//                     className="personal-info tab-pane active storetab"
//                     id="pi"
//                 >
//                     {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
//                     <div className="row">
//                         <div className="form-group col-sm-12 col-lg-12 mb-3">
//                             <label htmlFor="catName">Title</label>
//                             <input
//                                 type="text"
//                                 value={editedMediaData?.title}
//                                 onChange={handleTitleChange}
//                                 className="form-control custom-input my-3"
//                                 id="catName"
//                                 placeholder=""
//                             />
//                         </div>

//                         <div className="form-group col-sm-12 col-lg-12 mb-3">
//                             <label htmlFor="floatingInput">Status</label>
//                             <select
//                                 className="form-select custom-input my-3"
//                                 onChange={handleStatusChange}
//                                 value={editedMediaData?.statusid}
//                             >
//                                 {statusData?.map((item) => (
//                                     <option value={item.statusid}>{item.status}</option>
//                                 ))}
//                             </select>
//                         </div>
//                     </div>
//                     <div className="row">
//                         <div className="form-group col-sm-12 col-lg-12 mb-3">
//                             <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                 <DateTimePicker
//                                     // label="Date & Time (no past)"
//                                     value={value}
//                                     className="form-control custom-input my-2"
//                                     onChange={handleChange}
//                                     minDateTime={dayjs()}
//                                     shouldDisableTime={(timeValue, clockType) => {
//                                         const now = dayjs();
//                                         if (clockType === 'hours') {
//                                             return value.isSame(now, 'day') && timeValue < now.hour();
//                                         }
//                                         if (clockType === 'minutes') {
//                                             return value.isSame(now, 'day') && value.hour() === now.hour() && timeValue < now.minute();
//                                         }
//                                         return false;
//                                     }}
//                                     disablePast
//                                 />
//                             </LocalizationProvider>
//                         </div>
//                     </div>

//                     <div className="row">
//                         <div className="form-group col-sm-12 col-lg-12 mb-3">
//                             <button
//                                 type="submit"
//                                 onClick={handleSubmitClick}
//                                 className="btn btn-primary save-btn text-uppercase px-4 my-3"
//                             >
//                                 Save
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//                 <hr />
//             </div>
//         </div>
//     );
// }
// export default Editnotification;
import React, { useEffect, useState } from "react";
import { NavLink, useParams, useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { useJwt } from "react-jwt";
import {
    EditNotificationAPI,
    getByIdNotification,
    GetProductStatus
} from "../apiconfig/authService";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";

function Editnotification(props) {
    const navigate = useNavigate();
    const { isExpired } = useJwt(localStorage.getItem("accessToken"));
    const { id } = useParams();

    const setMediaTableViewMessage = props.setMessage;

    const [editedMediaData, setEditedMediaData] = useState({
        title: "",
        shortdescription: "",
        selecteddate: dayjs(),
        statusid: ""
    });
    const [statusData, setStatusData] = useState([]);
    const [value, setValue] = useState(dayjs());
    const [message, setMessage] = useState("");
    const [isMessageRed, setIsMessageRed] = useState(false);

    useEffect(() => {
        if (isExpired) {
            navigate("/");
        }
    }, [isExpired, navigate]);

    useEffect(() => {
        (async () => {
            try {
                const response = await getByIdNotification(
                    id,
                    localStorage.getItem("accessToken")
                );
                const data = response.data.response;
                setEditedMediaData(data);
                if (data.selecteddate) {
                    setValue(dayjs(data.selecteddate));
                }
            } catch (error) {
                console.error(error);
            }
        })();
    }, [id]);

    useEffect(() => {
        (async () => {
            try {
                const statusResponse = await GetProductStatus(
                    localStorage.getItem("accessToken")
                );
                setStatusData(statusResponse.data);
            } catch (error) {
                console.error(error);
            }
        })();
    }, []);

    const handleTitleChange = (e) => {
        setEditedMediaData({ ...editedMediaData, title: e.target.value });
    };
    const handleDescriptionChange = (e) => {
        setEditedMediaData({ ...editedMediaData, shortdescription: e.target.value });
    };

    const handleStatusChange = (e) => {
        setEditedMediaData({ ...editedMediaData, statusid: e.target.value });
    };

    const handleChange = (newValue) => {
        const now = dayjs();
        if (newValue && newValue.isBefore(now)) {
            setValue(now);
            setEditedMediaData({ ...editedMediaData, selecteddate: now.toISOString() });
        } else {
            setValue(newValue);
            setEditedMediaData({ ...editedMediaData, selecteddate: newValue.toISOString() });
        }
    };

    const handleSubmitClick = async (e) => {
        e.preventDefault();

        const data = {
            id,
            title: editedMediaData.title,
            shortdescription: editedMediaData.shortdescription,
            selecteddate: editedMediaData.selecteddate
        };

        try {
            const response = await EditNotificationAPI(data, localStorage.getItem("accessToken"));
            if (response.status === 200) {
                setMediaTableViewMessage(response.data.message);
                navigate("/notification");
            }
        } catch (err) {
            const errorMsg =
                err?.response?.data?.error || "An error occurred. Please try again later.";
            setIsMessageRed(true);
            setMessage(errorMsg);
            window.scrollTo(0, 0);
        }
    };

    return (
        <div className="dashboard-content">
            <Sidebar />
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">Edit Notification</h1>
                    <NavLink to="/media" className="btn btn-primary">
                        View All
                    </NavLink>
                </div>

                {message && (
                    <div
                        style={{ color: isMessageRed ? "red" : "black" }}
                        className="alert alert-primary"
                        role="alert"
                    >
                        {message}
                    </div>
                )}

                <div
                    role="tabpanel"
                    className="personal-info tab-pane active storetab"
                    id="pi"
                >
                    <div className="row">
                        <div className="form-group col-12 mb-3">
                            <label htmlFor="catName">Title</label>
                            <input
                                type="text"
                                value={editedMediaData.title}
                                onChange={handleTitleChange}
                                className="form-control custom-input my-3"
                                id="catName"
                            />
                        </div>

                        {/* <div className="form-group col-12 mb-3">
                        <label htmlFor="statusSelect">Status</label>
                        <select
                            className="form-select custom-input my-3"
                            onChange={handleStatusChange}
                            value={editedMediaData.statusid}
                            id="statusSelect"
                        >
                            <option value="">Select status</option>
                            {statusData?.map((item) => (
                                <option key={item.statusid} value={item.statusid}>
                                    {item.status}
                                </option>
                            ))}
                        </select>
                    </div> */}

                        <div className="form-group col-12 mb-3">
                            <label htmlFor="catName">shortdescription</label>
                            <input
                                type="text"
                                value={editedMediaData.shortdescription}
                                onChange={handleDescriptionChange}
                                className="form-control custom-input my-3"
                                id="catName"
                            />
                        </div>
                        <div className="form-group col-12 mb-3">
                            <label>Date&Time</label>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateTimePicker
                                    value={value}
                                    onChange={handleChange}
                                    disablePast
                                    slotProps={{
                                        textField: {
                                            variant: "outlined",
                                            fullWidth: true,
                                            error: false, // Ensure error is false to remove red styling
                                            sx: {
                                                '& .MuiOutlinedInput-root': {
                                                    '& fieldset': {
                                                        borderColor: '#ced4da', // normal border color
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: '#ced4da',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        borderColor: '#80bdff', // blue when focused (or whatever you want)
                                                    },
                                                },
                                            },
                                        },
                                    }}
                                />
                            </LocalizationProvider>

                        </div>

                        <div className="form-group col-12 mb-3">
                            <button
                                type="submit"
                                onClick={handleSubmitClick}
                                className="btn btn-primary save-btn text-uppercase px-4 my-3"
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
                <hr />
            </div>
        </div>
    );
}

export default Editnotification;
